export default __webpack_public_path__ + "static/media/p1.254d0a59.jpg";